<template lang="pug">
  div.choice
    p.mb-1.font-weight-bold Pic {{idx + 1}}
    div.choice__row
      v-checkbox(
        v-model="choice.isRight"
        :error="formErrors.hasError('answers')"
        @change="formErrors.validField('answers')"
      )
      div.choice-image
        FileLoader(
          :disabled="loading"
          accept=".jpg,.jpeg,.png"
          @onFileLoad="saveImageToServer"
        )
          template
            v-btn(outlined small :loading="loading")
              v-icon.mr-2 mdi-cloud-upload-outline
              span {{pictureName ? 'Change picture' : 'Upload picture'}}
      a.choice-image__name(v-if="pictureName" :href="choice.picture" target="_blank")
        v-icon.mr-2(size="medium") mdi-open-in-new
        span {{pictureName}}
      v-btn.remove-icon(
        @click="$emit('delete')"
        icon
      )
        v-icon mdi-delete
</template>

<script>
import FileLoader from "@/components/global/FileLoader.vue";
import MediaAPI from "@/services/api/exercise/api-media";
import QuestionChoiceDTO from "@/app/exercise/components/question/core/DTO/questionChoiceDTO";

export default {
  components: {FileLoader},
  props: {
    idx: {
      type: Number,
      required: true
    },
    choice: {
      type: QuestionChoiceDTO,
      required: true
    },
    formErrors: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      file: null,
      loading: false
    };
  },

  computed: {
    pictureName() {
      return this.choice.picture ? this.choice.picture.split('/').pop() : null;
    },
  },

  methods: {
    async saveImageToServer(file) {
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('file', file);
        const res = await MediaAPI.upload(formData, true);
        this.$emit('image-saved', res.file);
        this.cropModalVisible = false;
      } catch (error) {
        this.showErrorModal('Something went wrong')
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.choice {
  margin-bottom: 16px;

  &::v-deep {
    .v-input {
      margin-top: 0;
    }

    .v-input__slot {
      margin-bottom: 0;
    }

    .v-messages {
      display: none;
    }
  }

  &__row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #EEE;
    padding-bottom: 8px;
    padding-right: 40px;
    position: relative;
  }
}

.choice-image {
  margin-left: 8px;

  &__name {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 240px;
    margin-left: 20px;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }

    > i {
      transform: translateY(-1px);
    }
  }
}

.remove-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-60%);
}
</style>